export default {
    "filters": {
        "fromDate": "Fecha desde",
        "toDate": "Fecha hasta",
        "thisMonth": "Este mes",
        "lastMonth": "Mes anterior",
        "last30Days": "Últimos 30 días",
        "dateRange": "Rango de fechas",
        "dateIconLabel": {
            "predefinedRange": "Cambiar a filtros de fecha predefinidos",
            "manualRange": "Cambiar a filtros de fecha manuales"
        }
    },
    "actions": {
        "search": "Buscar",
        "newClient": "Nuevo cliente",
        "newUser": "Nuevo usuario"
    },
    "totals": "Totales",
    "selectClient": "Cliente",
    "selectClientPlaceholder": "Selecciona un cliente",
    "selectUserTypePlaceholder": "Selecciona un tipo de usuario",
    "forbiddenText": "No tienes acceso a esta página",
    "forbiddenTitle": "Prohibido",
    "headerActions": {
        "profile": "Mi Perfil",
        "leave": "Salir"
    },
    "requiredField": "Campo obligatorio",
    "invalidEmail": "Email no válido"
};